import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import history from '../router/history';
import createRootReducer from './reducers';

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware];
  if (process.env.REACT_APP_LOGGER) {
    middlewares.push(createLogger({ collapsed: true }));
  }
  const store = createStore(
    createRootReducer(history),
    composeWithDevToolsDevelopmentOnly(
      applyMiddleware(...middlewares, routerMiddleware(history)),
    ),
  );
  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);
  return store;
};

// Create store
const store = configureStore();

export default store;
